/**
 * Devices on Home (brands that do not sell, in money's place): where people watch, by viewers, as
 * ranked bars in plain names ("Apple TV", "Android phones and tablets"); groups of fewer than 5
 * viewers come merged as Other, last. The way to Analytics › Audience.
 */

import Button from "@web-ui/components/Button";
import Skeleton from "@web-ui/components/Skeleton";
import type { AudienceReport } from "../api";
import { BarList } from "../charts/bar-list";
import { NoData } from "../components/no-data";
import { platformLabel } from "../definitions";
import { count, percent } from "../format";
import type { Report } from "../use-report";

const SHOWN = 5;

export function DevicesCard({ report, audienceHref }: { report: Report<AudienceReport | null>; audienceHref: string }) {
  const a = report.data;
  const rows = a ? [...a.platforms].sort((x, y) => (x.key === "other" ? 1 : y.key === "other" ? -1 : y.viewers - x.viewers)).slice(0, SHOWN) : null;
  const total = a ? a.platforms.reduce((n, r) => n + r.viewers, 0) : 0;
  return (
    <section className={`card flex flex-col gap-3 transition-opacity ${report.stale ? "opacity-60" : ""}`} aria-labelledby="devices" aria-busy={(!a && !report.failed) || report.stale || undefined}>
      <div className="flex items-center gap-3">
        <div className="me-auto min-w-0 ps-card-inset py-1">
          <h2 id="devices" className="text-sub-title-1">Devices</h2>
          <p className="text-body-2 text-t-secondary">Where people watch, by viewers.</p>
        </div>
        <Button as="a" variant="ghost" size="sm" href={audienceHref}>See audience</Button>
      </div>
      {!rows ? (report.failed ? <p className="text-body-2 text-t-secondary ps-card-inset pb-2">Not available right now.</p> : <div className="px-card-inset pb-2"><Skeleton lines={SHOWN + 2} /></div>)
        : rows.length === 0 ? <NoData title="Nothing to show yet" />
        : <BarList label="Devices" bars={rows.map((r) => ({ key: r.key, label: platformLabel(r.key), value: r.viewers, text: count(r.viewers), detail: `${percent(total ? r.viewers / total : null)} of viewers` }))} />}
    </section>
  );
}
